module.exports = __webpack_public_path__ + "img/empty_4.b59bbb94.png";